/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const TenantSettingKey = {
    ONBOARDING_PROGRESS: 'ONBOARDING_PROGRESS'
} as const;
export type TenantSettingKey = typeof TenantSettingKey[keyof typeof TenantSettingKey];

